<template>
  <dialog-card title="Odwołaj i zakończ" :actions="actions" :handler="handlerClick" ref="card">
    <v-alert
      v-if="cancelPassword"
      class="mt-2 mb-2"
      dense
      outlined
      type="info"
    >
      <div class="text-caption font-weight-medium text-uppercase">Hasło</div>
      <div class="text-subtitle-1 font-weight-bold">{{ cancelPassword }}</div>
    </v-alert>
    <users-combo autofocus label="Użytkownik" :dense="false" :outlined="false" :users="users" @user-selected="usersChanged"
          :multiple="false" @keyup.alt.enter.native="onEnter" ref="user"></users-combo>
    <v-card-text class="py-0">
      <v-text-field class="mt-2" label="Komentarz końcowy" v-model="result.message" @keyup.enter.stop="onEnter">
      </v-text-field>
      <v-textarea class="mt-2" label="Dodatkowy komentarz" v-model="result.comment" rows="1" auto-grow
        @keydown.enter.exact.prevent="onEnter" @keydown.enter.shift.exact.prevent="result.comment += '\n'">
      </v-textarea>
    </v-card-text>
  </dialog-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: "CancelTaskDialog",
  data: () => ({
    actions: {
      false: 'Anuluj',
      true: {
        color: 'success',
        text: 'OK',
      },
    },
    result: {
      user: null,
      message: null,
      comment: null
    }
  }),
  mounted() {
    this.result.message = this.message
    this.result.comment = this.comment
    this.result.user = this.userSelected
  },
  watch: {
  },
  computed: {
  },
  props: {
    userSelected: {
      type: Array,
      default: () => null
    },
    users: {
      type: Promise,
      default: () => new Promise(resolve => resolve([]))
    },
    message: {
      type: String,
      default: () => null
    },
    comment: {
      type: String,
      default: () => null
    },
    cancelPassword: {
      type: String,
      default: () => null
    }

  },
  methods: {
    usersChanged(value) {
      if (_.isString(value)) {
        value = { id: 0, full_name: value }
      }
      this.result.user = value
    },
    onEnter() {
      this.$refs.card.$refs.actions.trigger(true)
    },
    handlerClick(res, action) {
      if (!action.key) {
        this.$emit('submit', action.key)
      }
      const validUser = this.result.user != null
      if (!validUser) {
        this.$refs.user.focus()
        return false
      }

      this.$emit('submit', action.key ? this.result : action.key)
    }
  },
};
</script>

